<template>
  <section>
    <section class="hero is-light">
      <div class="hero-body">
        <div class="container">
          <div class="columns">
            <div class="column">
              <h1 class="title">Estas son tus Empresas</h1>
              <h2 class="subtitle">Con cual deseas trabajar hoy?</h2>
            </div>
            <div class="column">
              <div class="field">
                <div class="control has-icons-left has-icons-right">
                  <input
                    class="input is-large"
                    type="text"
                    v-model="search"
                    placeholder="Buscar"
                  />
                  <span class="icon is-medium is-left">
                    <i class="material-icons">search</i>
                  </span>
                  <span class="icon is-medium is-right">
                    <i class="fas fa-check fa-lg"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <table class="table">
          <thead>
            <tr>
              <th></th>
              <th>Empresa</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in filteredItems" :key="item.$index">
              <td></td>
              <td>
                <h5 class="title is-5">
                  {{ item.nombrec }}
                  <small>{{ item.nit }}</small>
                </h5>
                <h6 class="subtitle is-6">{{ item.nombre }}</h6>
              </td>
              <td>
                <a @click="refEmp(item)" class="button is-link">Seleccionar</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </section>
</template>

<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
const filterItems = (query, data) => {
  return data.filter((el) => {
    const texto = el.nombre + el.nombrec + el.nit;
    if (texto.toLowerCase().indexOf(query.toLowerCase()) > -1) {
      return el;
    }
  });
};
export default {
  data() {
    return {
      empresas: [],
      search: "",
    };
  },
  computed: {
    ...mapState(["idtoken", "empresa"]),
    filteredItems: function () {
      return filterItems(this.search, this.empresas);
    },
  },
  methods: {
    async refEmp(p) {
      try {
        const _this = this;
        const result = await apiServices.get(`/changecompany/${p._id}`);
        if (result.data) {
          apiServices.get(`/empresacredential`).then((empresa) => {
            _this.$store.commit("refreshEmpresa", empresa.data);
          });
          apiServices.get(`/cuentas/reg`).then((result) => {
            _this.$store.commit("refreshCuentas", result.data);
          });
          apiServices.get(`/nits`).then((result) => {
            _this.$store.commit("refreshNits", result.data);
          });
          apiServices.get(`/productos`).then((result) => {
            _this.$store.commit("refreshProductos", result.data);
          });
          apiServices.get(`/bodegas`).then((result) => {
            _this.$store.commit("refreshBodegas", result.data);
          });
          apiServices.get(`/vendedores`).then((result) => {
            _this.$store.commit("refreshVendedores", result.data);
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async enviar(_this) {
      let result;
      try {
        result = await apiServices.get(`/empresas`);
        _this.empresas = result.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
  watch: {
    empresa(newv, oldv) {
      if (oldv._id !== newv._id) {
        this.$router.push("home");
      }
    },
  },
  created() {
    if (this.idtoken) {
      this.enviar(this);
    }
  },
};
</script>

<style lang="scss" scoped>
.icon-font-size {
  font-size: 17px;
  vertical-align: bottom;
}
</style>






// WEBPACK FOOTER //
// src/components/empresas/Empresas.vue